module.exports = __webpack_public_path__ + "fonts/lato-v11-latin-regular.eot";


//////////////////
// WEBPACK FOOTER
// ./src/js/core/fonts/lato-v11-latin-regular.eot
// module id = 16
// module chunks = 0